export default __webpack_public_path__ + "static/media/notification.f6c8d01b.svg";